export const gradients = {
  primary:
    "transparent linear-gradient(268deg, #8C72FF 0%, #C057EF 47%, #F0749B 100%) 0% 0% no-repeat padding-box",
};
